import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, UserPlus } from "lucide-react";

export default function UserManagement() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "operator" });
  const [busy, setBusy] = useState(false);

  async function load() { const { data } = await api.get("/users"); setUsers(data); }
  useEffect(() => { load(); }, []);

  async function submit(e) {
    e.preventDefault(); setBusy(true);
    try { await api.post("/users", form); toast.success("User created"); setForm({ name: "", email: "", password: "", role: "operator" }); await load(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  }

  async function del(id) {
    if (!confirm("Delete this user?")) return;
    try { await api.delete(`/users/${id}`); toast.success("Deleted"); await load(); }
    catch (e) { toast.error(apiErr(e)); }
  }

  return (
    <div className="space-y-6" data-testid="users-page">
      <div>
        <h1 className="text-3xl font-extrabold text-slate-900">User Management</h1>
        <p className="text-slate-500 mt-1">Admins only — create HO operators.</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-200 p-6 space-y-3">
          <h3 className="font-bold text-slate-800 flex items-center gap-2"><UserPlus className="h-5 w-5 text-blue-600" /> Add User</h3>
          <input required placeholder="Full Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} />
          <input required type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} />
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className={inputCls}>
            <option value="operator">Operator</option>
            <option value="admin">Admin</option>
          </select>
          <button disabled={busy} className="w-full py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700">Create</button>
        </form>

        <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr className="text-left text-xs uppercase text-slate-500 tracking-wider">
                <th className="py-3 px-4">Name</th>
                <th className="py-3 px-4">Email</th>
                <th className="py-3 px-4">Role</th>
                <th className="py-3 px-4 text-right"></th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-b border-slate-100">
                  <td className="py-3 px-4 font-semibold">{u.name}</td>
                  <td className="py-3 px-4 text-slate-600">{u.email}</td>
                  <td className="py-3 px-4"><span className="text-xs px-2 py-0.5 rounded-md bg-blue-50 text-blue-700 font-semibold uppercase">{u.role}</span></td>
                  <td className="py-3 px-4 text-right">
                    <button onClick={() => del(u.id)} className="text-red-500 hover:bg-red-50 p-2 rounded-lg"><Trash2 className="h-4 w-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const inputCls = "w-full h-11 px-3 rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition text-sm text-slate-900 bg-white";
